import Header from "./components/Header";
import MainSpace from "./components/MainSpace";
import AnimatedCursor from "react-animated-cursor";
import { motion, AnimateSharedLayout } from "framer-motion";
import { FaFeatherAlt } from "react-icons/fa";

function App() {
  return (
    <AnimateSharedLayout type="crossfade">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          overflow: "hidden",
          backgroundColor: "#121b1f",
          position: "relative",
        }}
      >
        <AnimatedCursor innerSize={8} outerSize={40} color="255,255,255" />

        <Header></Header>
        <MainSpace></MainSpace>
        <motion.div
          initial={{ fontSize: "0px", opacity: 1 }}
          animate={{
            fontSize: "1000px",
            opacity: 0,
            transitionEnd: {
              display: "none",
            },
          }}
          transition={{ duration: 4 }}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            color: "white",
          }}
        >
          <FaFeatherAlt />
        </motion.div>
      </div>
    </AnimateSharedLayout>
  );
}

export default App;
